import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/progressive-web/pwa-expertise.webp";

function Pwaexpertise() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={9} xl={8} xxl={8}>
            <h2>
              Unlock The Benefits of Our Expertise in Crafting Powerful Custom
              PWAs, and Create a Solution that Propels your Business to New
              Heights.
            </h2>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get in touch with our PWA Experts Now
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Pwaexpertise;
